import sw from 'stopword';

export function userIsLoggedIn(s) {
  return (nextState, replace) => {
    if (s.getState().user.profile.token === null) {
      replace(`/login?next=${nextState.pathname}`);
    }
  };
}

export function isLoggedIn(state) {
  return state.user.profile.token !== null;
}

export function getSourceOptions(response) {
  const empty = [['', 'Null']];
  return empty.concat(response.data.data.map(
    source => [source.id, source.name],
  ));
}

export function getUserOptions(response) {
  const empty = [['', 'Null']];
  return empty.concat(response.data.data.map(
    user => [user.id, user.name],
  ));
}

export function slugify(text) {
  const stripped = sw.removeStopwords(text.split(' ')).join(' ');
  return stripped.toString().substring(0, 60).toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')       // Remove all non-word chars
    .replace(/--+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

export function generateEntrySlug(entry, isAmp, full = false) {
  if (!entry.is_blitz) return entry.url;
  return entry.type === 'article'
  ? `${full ? 'https://blitzesports.com' : ''}/${entry.esport}${isAmp ? '/amp' : ''}/article/${entry.id}/${slugify(entry.title)}`
  : `${full ? 'https://blitzesports.com' : ''}/${entry.esport}${isAmp ? '/amp' : ''}/video/${entry.id}/${slugify(entry.title)}`;
}



// WEBPACK FOOTER //
// ./src/utils.js